import React from "react";

import Logo from "src/components/atoms/logo/Logo";

import "./ImagePlaceholder.scss";

interface ImagePlaceholderProps {
  minHeight?: number;
  classes?: string;
}

const ImagePlaceholder = ({ minHeight, classes }: ImagePlaceholderProps) => (
  <div
    className={`image-placeholder ${classes}`}
    style={{ minHeight: `${minHeight}px` }}
  >
    <Logo greyscale />
  </div>
);

export default ImagePlaceholder;
